"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Emoji_1 = require("./Emoji");
exports.default = Emoji_1.default;
//# sourceMappingURL=index.js.map